import * as React from 'react';

import { ActionAfterViewed } from '@cian/action-after-viewed-component';
import { useDispatch, useSelector } from 'react-redux';

import { loadMVK } from '../../../browser/services/mvk';
import { MVK } from '../../components/MVK';
import { MVKWrapper } from '../../components/MVK/MVKWrapper';
import { getMapApiKey } from '../../selectors/common';
import { getMvkLoadingError, getMvkData, hasMvk } from '../../selectors/mvk';
import { getSubdomain } from '../../selectors/subdomain';
import { MVKPreloader } from '../MVKPreloader';
import { trackMVKBlockAppearance } from './tracking';

export function MVKContainer() {
  const dispatch = useDispatch();
  const subdomain = useSelector(getSubdomain);
  const mvkData = useSelector(getMvkData);
  const isLoadingError = useSelector(getMvkLoadingError);
  const hasMVK = useSelector(hasMvk);
  const mapApiKey = useSelector(getMapApiKey);
  const [isReady, setMVKReadyState] = React.useState(false);

  const onMVKReady = React.useCallback(() => setMVKReadyState(true), [setMVKReadyState]);

  React.useEffect(() => {
    if (!hasMVK) {
      return;
    }

    dispatch(loadMVK());
  }, [hasMVK, dispatch]);

  if (!hasMVK || isLoadingError) {
    return null;
  }

  return (
    <ActionAfterViewed callback={trackMVKBlockAppearance}>
      <MVKWrapper>
        {!isReady && <MVKPreloader />}
        <MVK mvkData={mvkData} subdomain={subdomain} onMVKReady={onMVKReady} mapApiKey={mapApiKey} />
      </MVKWrapper>
    </ActionAfterViewed>
  );
}
